(function() {
  exports.TraitPackage = (function() {
    function TraitPackage() {
      this.id = null;
      this.trait_suppliers_id = null;
      this.name = '';
      this.suffix = '';
      this.description = '';
      this.active = true;
      this.num_active = 0;
    }

    return TraitPackage;

  })();

}).call(this);
